import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Table } from 'react-bootstrap';

import Edit from "../../../assets/images/edit.png";
import Trash from "../../../assets/images/delete.svg";
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import { toast } from 'react-toastify';

import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import edit from "../../../assets/images/edit.png";
import XLSFILE from '../../../assets/FixedRates-Trucker.xlsx'
import * as XLSX from 'xlsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faPlus, faBoxArchive, faDownload, faUpload } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { STATIONGRID, TRUCKERADDEMAIL, TRUCKEREDITEMAIL, TRUCKERDELEMAIL, TRUCKERSAVERATE, TRUCKERRATELIST } from '../../../Utils/conts.js';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const ManageRate = ({ rowData }) => {
    const [isLoading, setIsLoading] = useState(true);
    const isMounted = useRef(false);
    const [ratechart, setRateChart] = useState([]);
    const gridRefs = useRef({});
    const gridRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);

    const fetchData = async () => {
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        id: item.id,
                        value: item.station_id,
                        label: item.station_code
                    })) : []; // For multiselect
                    const transformData = innerData.Active ? innerData.Active.map((data) => ({
                        ...data,
                        value: data.id,
                        label: data.station_code,
                    })) : [];
                    // setBoardpoint(transformData);
                    setstations(transformedData); // For multiselect
                    // setFetchStation(innerData.Active);
                    // setSuggestionsBp(innerData.Active);
                    // setSuggestionsOffpoint(innerData.Active);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const reloadRates = async () => {
        try {
            const res = await withRFSToken.get(`fixed-rate-list?trucker_id=${rowData.trucker_id}`)
                .then(function (res) {
                    const innerData = res.data.Rows;
                    console.log("🚀 ~ .then ~ 2002:", res)
                    setRateChart(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (isMounted.current) return;
        reloadRates();
        fetchData();
        setIsLoading(false);
        setGridData({ });
        // loadDetails(truckerParent.trucker_id);
        // loadGrid();
        isMounted.current = true;
    }, []);
    const [stations, setstations] = useState([]);
    let [selected, setSelected] = useState([]);
    let [selectedop, setSelectedop] = useState([]);
    if (selected.length > 1) {
        selected = selected.slice(1);
    }
    if (selectedop.length > 1) {
        selectedop = selectedop.slice(1);
    }
    const handleBPSelectChange = async (seldata) => {
        const lastSelected = seldata.slice(-1);
        setSelected(lastSelected);
        // setSelected(selected);
        let payload = {}
        if (selectedop.length > 0 && seldata.length > 0) {
            payload = { boardpoint: seldata, offpoint: selectedop }
        } else if (selectedop.length > 0 && seldata.length == 0) {
            payload = { offpoint: selectedop }
        } else if (selectedop.length == 0 && seldata.length > 0) {
            payload = { boardpoint: seldata }
        } else if (selectedop.length == 0 && seldata.length == 0) {
            payload = {}
        }
        try {
            const res = await withRFSToken.post(TRUCKERRATELIST, payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    setRateChart(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // if (selected && selectedop) {
        //     console.log('111', selected);
        //     try {
        //         const res = await withRFSToken.post(TRUCKERRATELIST, { boardpoint: selected, offpoint: selectedop })
        //             .then(function (res) {
        //                 const innerData = res.data.response_data;
        //                 // console.log("🚀 ~ .then ~ innerData:", innerData)
        //                 setRateChart(innerData);
        //             });

        //     } catch (error) {
        //         console.error('Error fetching data:', error);
        //     }
        // } else if (selected && !selectedop) {
        //     console.log('222', selected);
        //     try {
        //         const res = await withRFSToken.post(TRUCKERRATELIST, { boardpoint: selected })
        //             .then(function (res) {
        //                 const innerData = res.data.response_data;
        //                 // console.log("🚀 ~ .then ~ innerData:", innerData)
        //                 setRateChart(innerData);
        //             });

        //     } catch (error) {
        //         console.error('Error fetching data:', error);
        //     }
        // } else {

        // }

    };
    const handleOPSelectChange = async (seldata) => {
        setSelectedop(seldata)
        let payload = {}
        if (selected.length > 0 && seldata.length > 0) {
            payload = { boardpoint: selected, offpoint: seldata }
        } else if (selected.length > 0 && seldata.length == 0) {
            payload = { boardpoint: selected }
        } else if (selected.length == 0 && seldata.length > 0) {
            payload = { offpoint: seldata }
        } else if (selected.length == 0 && seldata.length == 0) {
            payload = {}
        }
        try {
            const res = await withRFSToken.post(TRUCKERRATELIST, payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    setRateChart(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }

        // if (selectedop && seldata) {
        //     try {
        //         const res = await withRFSToken.post(TRUCKERRATELIST, { boardpoint: selected, offpoint: seldata })
        //             .then(function (res) {
        //                 const innerData = res.data.response_data;
        //                 // console.log("🚀 ~ .then ~ innerData:", innerData)
        //                 setRateChart(innerData);
        //             });

        //     } catch (error) {
        //         console.error('Error fetching data:', error);
        //     }
        // } else if (selectedop && !seldata) {
        //     try {
        //         const res = await withRFSToken.post(TRUCKERRATELIST, { offpoint: seldata })
        //             .then(function (res) {
        //                 const innerData = res.data.response_data;
        //                 // console.log("🚀 ~ .then ~ innerData:", innerData)
        //                 setRateChart(innerData);
        //             });

        //     } catch (error) {
        //         console.error('Error fetching data:', error);
        //     }
        // } else {

        // }
    };
    // UPLOAD
    const currencies = [
        { value: "EUR", label: "EUR (€) - Euro" },
        { value: "USD", label: "USD ($) - US Dollar" },
        { value: "PHP", label: "PHP (₱) - Philippine Peso" },
        { value: "JPY", label: "JPY (¥) - Japanese Yen" },
        { value: "GBP", label: "GBP (£) - British Pound" },
        { value: "AUD", label: "AUD (A$) - Australian Dollar" },
        { value: "CHF", label: "CHF (Fr.) - Swiss Franc" },
        { value: "CAD", label: "CAD (C$) - Canadian Dollar" },
        { value: "MXN", label: "MXN ($) - Mexican Peso" },
        { value: "CNY", label: "CNY (¥) - Chinese Yuan" },
        { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar" },
        { value: "SEK", label: "SEK (kr) - Swedish Krona" },
        { value: "RUB", label: "RUB (₽) - Russian Ruble" },
        { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar" },
        { value: "NOK", label: "NOK (kr) - Norwegian Krone" },
        { value: "SGD", label: "SGD (S$) - Singapore Dollar" },
        { value: "TRY", label: "TRY (₺) - Turkish Lira" },
        { value: "KRW", label: "KRW (₩) - South Korean Won" },
        { value: "ZAR", label: "ZAR (R) - South African Rand" },
        { value: "BRL", label: "BRL (R$) - Brazilian Real" },
        { value: "INR", label: "INR (₹) - Indian Rupee" },
        { value: "SAR", label: "SAR (﷼) - Saudi Riyal" },
        { value: "DKK", label: "DKK (kr) - Danish Krone" },
        { value: "RON", label: "RON (lei) - Romanian Leu" },
        { value: "XAF", label: "XAF (Fr) - Central African CFA Franc" },
        { value: "XOF", label: "XOF (Fr) - West African CFA Franc" },
        { value: "DOP", label: "DOP (RD$) - Dominican Peso" },
        { value: "HTG", label: "HTG (G) - Haitian Gourde" },
        { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar" },
        { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar" },
        { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar" },
        { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder" },
        { value: "COP", label: "COP (COL$) - Colombian Peso" },
        { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights" },
        { value: "XBT", label: "XBT (₿) - Bitcoin" },
        { value: "WGH", label: "WGH - West German Hard Currency" }
    ];
    const [showModal, setShowModal] = useState(false);
    const [modalRadioValue, setModalRadioValue] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [modalContent, setModalContent] = useState('EUR');
    const [fileName, setFileName] = useState('');
    const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };

    const handleConfirmation = (confirm) => {
        if (confirm) {
            setShowModal(false);
            window.location.href = '/ULDControl'
        } else {
            setShowModal(false);
        }
    }
    const handleFileChange = (event) => {
        console.log("🚀 ~ handleFileChange ~ event:", event)
        setSelectedFile(event.target.files[0]);

        const input = event.target;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            setFileName(file.name);
            setSelectedFile(file);

            // const reader = new FileReader();
            // reader.onload = (e) => {
            //     setFileData(e.target.result);
            // };
            // reader.readAsText(file); // Use readAsText to read the content of the file
        }
    };
    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file first!");
            return;
        }
        // setUploading(true);
        // console.log('300', selectedFile);

        // if (selectedFile) {
        //     const reader = new FileReader();
        //     reader.onload = (e) => {
        //         const data = e.target.result;
        //         const workbook = XLSX.read(data, { type: "binary" });
        //         const sheetName = workbook.SheetNames[0];
        //         const worksheet = workbook.Sheets[sheetName];
        //         const json = XLSX.utils.sheet_to_json(worksheet);
        //         console.log("🚀 ~ handleUpload ~ json:", json)

        //     };
        //     reader.readAsBinaryString(selectedFile);
        // } else {
        //     toast.error("All Fields Are Mandatory", { autoClose: 1000 });
        // }

        // const xlFileData = new FormData();
        // xlFileData.append('uld_file', selectedFile);
        // const formData = new FormData();
        // formData.append('uld_file', selectedFile, fileName);

        if (selectedFile) {
            // console.log("🚀 ~ handleUpload ~ selectedFile:", selectedFile)

            try {
                const payload = { ...selectedFile, }
                const formData = new FormData();
                formData.append("fix_rate_file", selectedFile);
                formData.append("trucker_id", rowData.trucker_id);
                formData.append("currency", modalContent);
                console.log("🚀 ~ handleUpload ~ selectedFile:", selectedFile)
                console.log("🚀 ~ handleUpload ~ formData:", formData)

                const res = await withRFSToken.post('upload-fix-rate', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (res.data.response_code == 200) {
                    toast.success(res.data.response_msg);
                    setShowModal(false)
                    reloadRates()
                    setFileName('');
                }

            } catch (error) {
                console.error("There was an error uploading the file!", error);
            } finally {
                // setUploading(false);
            }
        }
    };

    const handleDownloadClick = () => {
        const a = document.createElement('a');
        a.href = XLSFILE;
        a.download = 'FixedRates-Trucker.xlsx'; // Name for the downloaded file
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'board_point', type: 'string' },
                    { name: 'off_point', type: 'string' },
                    { name: 'via_station', type: 'string' },
                    { name: 'min', type: 'string' },
                    { name: 'per_kg', type: 'string' },
                    { name: 'position_1st', type: 'string' },
                    { name: 'position_2nd', type: 'string' },
                    { name: 'position_3rd', type: 'string' },
                    { name: 'ftl', type: 'string' },
                    { name: 'handling_cost', type: 'string' }
                ],
                // id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}fixed-rate-list?trucker_id=${rowData.trucker_id}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Action', datafield: '', width: '8%', filterable: false,
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        return `<div class="grid_actions"><img class="door_edit" src="${Edit}"/>`;
                    }
                },
                //{ text: 'Boardpoint', datafield: 'board_point', width: '8%', filtertype: 'textbox', },
                //{ text: 'Offpoint', datafield: 'off_point', width: '8%', filtertype: 'textbox', },
                { text: 'Boardpoint', datafield: 'board_point', width: '8%', filtertype: 'checkedlist', filteritems: stations, },
                { text: 'Offpoint', datafield: 'off_point', width: '8%', filtertype: 'checkedlist', filteritems: stations, },
                { text: 'Via Station', datafield: 'via_station', width: '8%', filtertype: 'textbox', },
                { text: 'Min', datafield: 'min', width: '8%', filtertype: 'textbox', },
                { text: 'Per KG', datafield: 'per_kg', width: '8%', filtertype: 'textbox', },
                { text: '1 Position', datafield: 'position_1st', width: '8%', filtertype: 'textbox', },
                { text: '2 Position', datafield: 'position_2nd', width: '8%', filtertype: 'textbox', },
                { text: '3 Position', datafield: 'position_3rd', width: '8%', filtertype: 'textbox', },
                { text: 'FTL', datafield: 'ftl', width: '8%', filtertype: 'textbox', },
                { text: 'Handling Cost (Per KG)', datafield: 'handling_cost', width: '15%', filtertype: 'textbox', },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 800,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // rendered: function () {
                //   const rows = window.$(gridRef.current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(gridRef.current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                console.log("🚀 ~ rowDiv:", rowDiv)
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);

                // loadDetails(rowData.awbId, 'E');
                // window.location.href='/ForwarderShipments/CreateCargo'
                // setEditData(dataToSend);
                // setShowEdit(true);
            });

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awbId;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.awbId === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awbId === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awbId;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awbId !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (![0, 1, 3, 6, 7].includes(event.args.columnindex)) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    //   loadDetails(args.awbId);
                    // setSelectedRowData(args)
                }
            });
            // }
        }
    }, [gridData]);

    const loadGrid = () => {
        // const token = 'Bearer ' + localStorage.RFS;
        jqxCookieCall()
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}fixed-rate-list?trucker_id=${rowData.trucker_id}`,
            root: 'Rows',
            cache: false,
            pagesize: 50,
            datafields: [
                { name: 'board_point', type: 'string' },
                { name: 'off_point', type: 'string' },
                { name: 'via_station', type: 'string' },
                { name: 'min', type: 'string' },
                { name: 'per_kg', type: 'string' },
                { name: 'position_1st', type: 'string' },
                { name: 'position_2nd', type: 'string' },
                { name: 'position_3rd', type: 'string' },
                { name: 'ftl', type: 'string' },
                { name: 'handling_cost', type: 'string' }
            ],
            // beforeSend: (jqXHR) => {
            //     jqXHR.setRequestHeader('Authorization', token);
            // },
            filter: function (allfilters) {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: function (data) {

            }
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const stationOptions = stations.map((station) => ({
            label: station.label,
            value: station.value
        }));
        const columns = [
            {
                text: 'Action', datafield: '', width: '8%', filterable: false,
                cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    return `<div class="grid_actions"><img class="door_edit" src="${Edit}"/>`;
                }
            },
            //{ text: 'Boardpoint', datafield: 'board_point', width: '8%', filtertype: 'textbox', },
            //{ text: 'Offpoint', datafield: 'off_point', width: '8%', filtertype: 'textbox', },
            {
                text: 'Boardpoint',
                datafield: 'board_point',
                width: '8%',
                filtertype: 'checkedlist',
                filteritems: stationOptions,
            },
            {
                text: 'Offpoint',
                datafield: 'off_point',
                width: '8%',
                filtertype: 'checkedlist',
                filteritems: stationOptions,
            },
            { text: 'Via Station', datafield: 'via_station', width: '8%', filtertype: 'textbox', },
            { text: 'Min', datafield: 'min', width: '8%', filtertype: 'textbox', },
            { text: 'Per KG', datafield: 'per_kg', width: '8%', filtertype: 'textbox', },
            { text: '1 Position', datafield: 'position_1st', width: '8%', filtertype: 'textbox', },
            { text: '2 Position', datafield: 'position_2nd', width: '8%', filtertype: 'textbox', },
            { text: '3 Position', datafield: 'position_3rd', width: '8%', filtertype: 'textbox', },
            { text: 'FTL', datafield: 'ftl', width: '8%', filtertype: 'textbox', },
            { text: 'Handling Cost (Per KG)', datafield: 'handling_cost', width: '15%', filtertype: 'textbox', },
        ];
        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pageable: true,
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
        };
        window.$(gridRefs.current).jqxGrid(gridOptions);
    };

    return (
        <>
            {console.log("aaaaaaaaaaaaaaaaaaa", stations)}
            <div className='pt-4'>
                <h4>Fixed Rates</h4>
                <p>Add truckers and manage truckers.</p>
            </div>
            <div >
                <Form.Group className='d-flex mb-3 rate_search' controlId="exampleForm.ControlInput1">
                    {/* <div className='d-flex align-items-center'>
                        <Form.Label inline>Boardpoint</Form.Label>
                        <MultiSelect
                            inline
                            options={stations}
                            isCreatable={true}
                            hasSelectAll={false}
                            showCheckbox={false}
                            value={selected}
                            selected={selected}
                            name='boardpoint'
                            onChange={handleBPSelectChange}
                        />
                    </div>
                    <div className='d-flex align-items-center'>
                        <Form.Label inline>Offpoint</Form.Label>
                        <MultiSelect
                            inline
                            options={stations}
                            isCreatable={true}
                            hasSelectAll={false}
                            showCheckbox={false}
                            value={selectedop}
                            selected={selectedop}
                            name='offpoint'
                            onChange={handleOPSelectChange}
                        />

                    </div> */}
                    <div className='ms-auto'><Button onClick={() => setShowModal(true)}><FontAwesomeIcon icon={faFileImport} /> Upload</Button></div>
                </Form.Group>
            </div>
            <div>
                {!isLoading && <div ref={gridRef} className="staion_grid" />}
                {/* <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>Boardpoint</th>
                            <th>Offpoint</th>
                            <th>Via Station</th>
                            <th>Min</th>
                            <th>Per KG</th>
                            <th>1 Position</th>
                            <th>2 Position</th>
                            <th>3 Position</th>
                            <th>FTL</th>
                            <th>Handling Cost (Per KG)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ratechart && ratechart.map(rates => (
                            <tr>
                                <td><img src={edit} class="row_edit" /></td>
                                <td>{rates.board_point}</td>
                                <td>{rates.off_point}</td>
                                <td>{rates.via_station}</td>
                                <td>{rates.min}</td>
                                <td>{rates.per_kg}</td>
                                <td>{rates.position_1st}</td>
                                <td>{rates.position_2nd}</td>
                                <td>{rates.position_3rd}</td>
                                <td>{rates.ftl}</td>
                                <td>{rates.handling_cost}</td>
                               
                            </tr>
                        ))}
                    </tbody>
                </Table> */}
            </div>
            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Import Excel</h3>
                    <p>Upload the filled in template to add ULDs.</p>
                    <div className='asset_midle'>
                        <div className='mb-4'>
                            <Select
                                options={currencies}
                                onChange={(e) => setModalContent(e.value)}
                                // placeholder="--"
                                className="autoslct mx-auto"
                                name="air_freight_currency"
                                value={currencies.find(option => option.value === modalContent) || ''}
                            />
                        </div>
                        <div className='upload_tmpl'>
                            <button onClick={handleDownloadClick}>
                                <FontAwesomeIcon icon={faDownload} />
                                <span>Download Template (Excel) </span>
                            </button>
                            <div className="form-group inputDnD">
                                <FontAwesomeIcon icon={faUpload} />
                                <input
                                    type="file" className="form-control-file "
                                    id="inputFile"
                                    // accept=".xlsx, .xls, .csv"
                                    onChange={handleFileChange}
                                    data-title="Upload your file (Excel)" />

                                {/* {fileData && (
                                    <div>
                                        <h4>File Data:</h4>
                                        <pre>{fileData}</pre>
                                    </div>
                                )} */}
                            </div>
                        </div>

                        {fileName && (
                            <div className='rafilname'>
                                <p>File Name: {fileName}</p>
                            </div>
                        )}


                        {/* <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            accept=".xlsx, .xls, .csv"
                        /> */}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ManageRate
